import { render, staticRenderFns } from "./ReportDisabled.vue?vue&type=template&id=6d39d0c6&scoped=true"
import script from "./ReportDisabled.vue?vue&type=script&lang=js"
export * from "./ReportDisabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d39d0c6",
  null
  
)

export default component.exports